export const request = (options = {}, context = {}) => {
  const { project } = context
  const {
    pattern = ':packageFolder/:name/package.json'
  } = options

  const packageDocs = project.routeDocuments(pattern)

  return packageDocs.map(result => {
    if (options.load) {
      result.doc = result.doc.ready
    }

    return result
  })
}

export default request



// WEBPACK FOOTER //
// ./src/data-sources/packages.js